import { render } from "./InicioNegocioComponent.vue?vue&type=template&id=11e29d71&scoped=true"
import script from "./InicioNegocioComponent.vue?vue&type=script&lang=js"
export * from "./InicioNegocioComponent.vue?vue&type=script&lang=js"

import "./InicioNegocioComponent.vue?vue&type=style&index=0&id=11e29d71&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e29d71"]])

export default __exports__